<script>
	import { sucursal, sucursalStore } from "./stores/store.js";
	import Navbar from './components/Navbar.svelte';

</script>

<Navbar/>
<br/><br/>
<div class='text-center mt-5'>
    <img src='images/logo-premium-outlet.png' alt='' style='width:400px;'/>
    <p>Está en la <strong>{$sucursalStore[$sucursal]}</strong></p>
    
</div>